export default __webpack_public_path__ + "locales/ar-SA/Common.json?hash=35f96b981a62486594b786c97bae8e71";